export const IMAGE_BASE_WIDTH = 940;
export const IMAGE_BASE_HEIGHT = 650;
